let _cached = null

export function detectDevice() {
  if (_cached) return _cached
  const d = Math.min(window.screen.width, window.screen.height)
  const isPhone = d <= 430
  const isTablet = !isPhone && d <= 1024
  _cached = { isPhone, isTablet, isDesktop: !isPhone && !isTablet }
  return _cached
}

export function isPhone() { return detectDevice().isPhone }
export function isTablet() { return detectDevice().isTablet }
